import { SessionFragment } from 'generated/resources/graphql'

import { stringToDate } from 'modules/core/lib/dates'

interface Props {
  sessions: SessionFragment[]
}
export const useSessionsData = ({ sessions }: Props) => {
  const getStartDate = () => {
    const dates = sessions.map((session) => session.startsAt)

    return dates.reduce((a, b) =>
      stringToDate(a, 'backend_datetime') < stringToDate(b, 'backend_datetime') ? a : b
    )
  }

  const getEndDate = () => {
    const dates = sessions.map((session) => session.endsAt)

    return dates.reduce((a, b) =>
      stringToDate(a, 'backend_datetime') > stringToDate(b, 'backend_datetime') ? a : b
    )
  }

  const getCombinedModality = () => {
    const modalities = sessions.map((session) => session.modality).filter(Boolean)

    if (!modalities || modalities.length === 0) return undefined

    return modalities.reduce((a, b) => {
      if (a != b) return 'mixed'

      return a
    })
  }

  return { getStartDate, getEndDate, getCombinedModality }
}
